import {signout} from "./api-auth";

const auth = {
    authenticate(accessToken,usertype,user,cb){
        if(typeof window !== "undefined")
            sessionStorage.setItem('accessToken',JSON.stringify(accessToken))
            sessionStorage.setItem('usertype',usertype)
            sessionStorage.setItem('user',user)
        cb()
    },
    isAuthenticated(){
        if(typeof window == "undefined") return false
        if(sessionStorage.getItem('accessToken'))
            return JSON.parse(sessionStorage.getItem('accessToken'))
        else
            return false
    },
    getuserType(){
        var usertype = sessionStorage.getItem('usertype');
        if(usertype === "1") return "customer"
        if(usertype === "2") return "clerk"
        if(usertype === "3") return "manager"
        if(usertype === "4") return "admin"
    },
    getUser(){
        var user = sessionStorage.getItem('user');
        return user;
    },
    clearJWT(cb){
        if(typeof window !== "undefined")
            sessionStorage.removeItem('accessToken')
        cb()
        signout().then((data)=>{
            document.cookie = "t=;expires=Thu, 01 Jan 1970 00:00:00 UTC; paht=/;"
        })
    }
}

export default auth